import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import styles from './LoadingSpinner.module.css';

export function LoadingSpinner() {
  const { store } = usePlayerContext();
  const loading = useStore(store, useCallback(s => s.loading, []));
  const isOnline = useStore(store, useCallback(s => s.isOnline, []));
  const startupHiding = useStore(store, useCallback(s => s.startupHiding, []));
  const visible = loading && isOnline;

  return (
    <div
      className={
        `${styles.spinner}` +
        `${visible ? ` ${styles.visible}` : ''}` +
        `${visible && startupHiding ? ` ${styles.opaque}` : ''}`
      }
    >
      <div className={styles.ring} />
    </div>
  );
}
